import { getSVG } from '../icons/MovementIcons';

export const ToothInfoAndButtons = ({ clickedTooth, selectedTooth, resetSelectedToothToInitialPosition, undoSelectedToothLastMovement, restoreSelectedToothToNextPosition, isStepEditMode }) => {
    const hasSelectedTooth = !!clickedTooth;
    const isStepInitial = hasSelectedTooth && clickedTooth.isStepInit;
    const hasNoMovements = hasSelectedTooth && clickedTooth.movementActual < 1;
    const isAtLastMovement = hasSelectedTooth && clickedTooth.mouvements.length === clickedTooth.movementActual + 1;
    const hasOnlyOneMovement = hasSelectedTooth && clickedTooth.mouvements.length === 1;

    const isResetDisabled = !hasSelectedTooth || isStepInitial || hasNoMovements || isStepEditMode;
    const isUndoDisabled = !hasSelectedTooth || hasNoMovements || isStepInitial || isStepEditMode;
    const isRestoreDisabled = !hasSelectedTooth || (isAtLastMovement && !isStepInitial) || hasOnlyOneMovement || isStepEditMode;

    return (
        <div className="left-panel-buttons">
            <div className="left-panel-info">
                <span>{getSVG("tooth")}</span>
                <span className="current-tooth-value">
                    {hasSelectedTooth ? selectedTooth.id : "∅"}
                </span>
            </div>
            <button
                className="left-panel-delete-button"
                onClick={resetSelectedToothToInitialPosition}
                disabled={isResetDisabled}
            >
                🗘
            </button>
            <button
                className="left-panel-delete-button"
                onClick={undoSelectedToothLastMovement}
                disabled={isUndoDisabled}
            >
                ↶
            </button>
            <button
                className="left-panel-delete-button"
                onClick={restoreSelectedToothToNextPosition}
                disabled={isRestoreDisabled}
            >
                ↷
            </button>
        </div>
    );
};
